// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import(/* webpackPreload: true */ "../stylesheets/application.scss");
import(/* webpackPreload: true */ "../stylesheets/custom.scss");
import(
  /* webpackPreload: true */ "../../../node_modules/element-ui/lib/theme-chalk/index.css"
);
import(/* webpackPreload: true */ "../stylesheets/element-variables.scss");

import 'jquery/dist/jquery.js'
import 'popper.js/dist/popper.js'
import 'bootstrap/dist/js/bootstrap.js'
import '@fortawesome/fontawesome-free/js/all'
import 'element-ui/lib/theme-chalk/display.css'